import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);
Vue.use(require('vue-moment'));

export default new Vuetify({
});
